module.exports = __webpack_public_path__ + "img/101-Walnuss Kolonial - Chataignier.jpg";